import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { withRouteData, withSiteData } from 'react-static';

import BrandButton from '../../brand/BrandButton';

const GetStartedCta = ({ appDomain, trackingData, size, className }) => {
  return (
    <BrandButton
      tone="white"
      size={size}
      pill
      to={`${appDomain}/discover?showPreviewsModal=1`}
      openInNewTab
      trackingData={{ ...trackingData, title: 'Start Listening' }}
      className={className}
    >
      <FormattedMessage id="header.cta.start-listening" defaultMessage="Start Listening" />
    </BrandButton>
  );
};

GetStartedCta.propTypes = {
  appDomain: PropTypes.string.isRequired,
  trackingData: PropTypes.object,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  className: PropTypes.string,
};

GetStartedCta.defaultProps = {
  size: 'small',
};

export default withSiteData(withRouteData(GetStartedCta));



// WEBPACK FOOTER //
// /tmp/build_2cb81483/src/components/main/header/GetStartedCta.js